import React from 'react';

const SubTeam = () => {
  return (
    <section className='sub-text-box' id='sub-text-box'>
      <h1>Team</h1>
      <p>SISTERHOOD - BROTHERHOOD; COMMON GOAL.</p>
    </section>
  );
};

export default SubTeam;
